





































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import moment from 'moment'

import config from '../config'
import { Change, UserSettings } from '../store/timeline'

@Component({
})
export default class UserMenu extends Vue {
    @State(state => state.auth.username) username!: string
    @State(state => state.timeline.userSettings) settings!: UserSettings
    fav = true
    menu = false
    message = false
    hints = true
    notificationChoices = [
        {
            value: null,
            text: 'Disabled',
        },
        {
            value: 7 * 24 * 60 * 60,
            text: 'Weekly',
        },
        {
            value: 24 * 60 * 60,
            text: 'Daily',
        },
        {
            value: 8 * 60 * 60,
            text: '3 times per day',
        },
        {
            value: 60 * 60,
            text: 'Hourly',
        },
    ]
    notificationLoading = false
    async setNotificationInterval(interval: number) {
        this.notificationLoading = true
        try {
            this.$store.dispatch('timeline/updateUserSettings', {
                notification_interval: interval,
            })
        } finally {
            this.notificationLoading = false
        }
    }
    logout() {
        this.$store.dispatch('auth/logout')
        this.$store.dispatch('timeline/clear')
    }
    changePassword(ev: any) {
        this.$router.push({ name: 'change-password' })
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserMenu.vue